import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from '@/pages/home/components/Hero';
import Stats from '@/pages/home/components/Stats';
import Services from '@/pages/home/components/Services';
import Products from '@/pages/home/components/Products';
import Industries from '@/pages/home/components/Industries';
import Process from '@/pages/home/components/Process';
import GlobalPresence from '@/pages/home/components/GlobalPresence';
import Testimonials from '@/pages/home/components/Testimonials';
import Contact from '@/pages/home/components/Contact';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Stats />
        <Services />
        <Products />
        <Industries />
        <Process />
        <GlobalPresence />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}